"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropdownContainer = exports.dropdownItem = exports.dropDownContainer = exports.optionIcon = exports.optionWrapper = exports.accentButton = exports.actionIcon = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var actionIcon =
/*#__PURE__*/
(0, _reactEmotion.css)("fill:", _themeConfig.default.color.dark.silver, ";width:16px;height:16px;");
exports.actionIcon = actionIcon;
var accentButton =
/*#__PURE__*/
(0, _reactEmotion.css)("cursor:pointer;padding:0px !important;margin:0px !important;");
exports.accentButton = accentButton;
var optionWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;align-items:center;padding:12px 16px 10px 12px !important;&:active{background-color:", _themeConfig.default.color.dark.sapphire, "!important;}&:hover{background-color:", _themeConfig.default.color.dark.white0_06, "!important;}");
exports.optionWrapper = optionWrapper;
var optionIcon =
/*#__PURE__*/
(0, _reactEmotion.css)("margin-right:8px;width:14px;height:14px;");
exports.optionIcon = optionIcon;
var dropDownContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:column;justify-content:center;");
exports.dropDownContainer = dropDownContainer;
var dropdownItem =
/*#__PURE__*/
(0, _reactEmotion.css)("padding:14px 18px;");
exports.dropdownItem = dropdownItem;
var dropdownContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("background-color:", _themeConfig.default.color.dark.earth, " !important;&::after{left:156px !important;border-bottom-color:", _themeConfig.default.color.dark.earth, " !important;}");
exports.dropdownContainer = dropdownContainer;